module.exports = __webpack_public_path__ + "static/media/btn_colaps.3584d52b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/btn_colaps.svg
// module id = 319
// module chunks = 0